import SparklineDataCard from 'components/data-card/variants/sparkline-data-card/sparkline-data-card-component';
import { sparklineMinMaxDiff } from 'components/data-card/variants/sparkline-data-card/sparkline-data-card.utils';
import { useSearchQueryContext } from 'components/search/search.hooks';
import SummaryCardBoundary from 'components/summary-card-boundary/summary-card-boundary.component';
import { useTranslation } from 'react-i18next';

const queryName = 'brandPointsSummaryCards';

const getSparklineChartProps = (data: number[] | undefined) => {
  return {
    yAxis: sparklineMinMaxDiff(data || []),
  };
};

const BrandPointsSummaryCards = () => {
  const { t } = useTranslation();
  const { data } = useSearchQueryContext(queryName);
  const {
    startingBalance,
    pointsEarned,
    pointsRedeemed,
    pointsExpired,
    endingBalance,
  } = data ?? {};

  return (
    <SummaryCardBoundary queryName={queryName} expectedCount={5}>
      <SparklineDataCard
        title={t('page.loyaltyPerformanceReport.startingBalance.label')}
        value={startingBalance?.value}
        valueType={startingBalance?.cardType}
        previousPeriodPercent={startingBalance?.comparisonNumber}
        sparklineData={startingBalance?.sparkLineData}
        SparkLineChartProps={getSparklineChartProps(
          startingBalance?.sparkLineData,
        )}
      />
      <SparklineDataCard
        title={t('page.loyaltyPerformanceReport.pointsEarned.label')}
        value={pointsEarned?.value}
        valueType={pointsEarned?.cardType}
        previousPeriodPercent={pointsEarned?.comparisonNumber}
        sparklineData={pointsEarned?.sparkLineData}
        SparkLineChartProps={getSparklineChartProps(
          pointsEarned?.sparkLineData,
        )}
      />
      <SparklineDataCard
        title={t('page.loyaltyPerformanceReport.pointsRedeemed.label')}
        value={pointsRedeemed?.value}
        valueType={pointsRedeemed?.cardType}
        previousPeriodPercent={pointsRedeemed?.comparisonNumber}
        sparklineData={pointsRedeemed?.sparkLineData}
        SparkLineChartProps={getSparklineChartProps(
          pointsRedeemed?.sparkLineData,
        )}
      />
      <SparklineDataCard
        title={t('page.loyaltyPerformanceReport.pointsExpired.label')}
        value={pointsExpired?.value}
        valueType={pointsExpired?.cardType}
        previousPeriodPercent={pointsExpired?.comparisonNumber}
        sparklineData={pointsExpired?.sparkLineData}
        SparkLineChartProps={getSparklineChartProps(
          pointsExpired?.sparkLineData,
        )}
      />
      <SparklineDataCard
        title={t('page.loyaltyPerformanceReport.endingBalance.label')}
        value={endingBalance?.value}
        valueType={endingBalance?.cardType}
        previousPeriodPercent={endingBalance?.comparisonNumber}
        sparklineData={endingBalance?.sparkLineData}
        SparkLineChartProps={getSparklineChartProps(
          endingBalance?.sparkLineData,
        )}
      />
    </SummaryCardBoundary>
  );
};

export default BrandPointsSummaryCards;
